/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { DirectDebitReturnService } from './services/direct-debit-return.service';
import { HealthService } from './services/health.service';
import { NotesService } from './services/notes.service';
import { LockingService } from './services/locking.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    DirectDebitReturnService,
    HealthService,
    NotesService,
    LockingService,
    ApiConfiguration
  ],
})
export class DirectDebitReturnModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<DirectDebitReturnModule> {
    return {
      ngModule: DirectDebitReturnModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: DirectDebitReturnModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('DirectDebitReturnModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
